import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { DialogData } from 'src/app/shared/components/dialogs/get-time/get-time.component';
import { CommonModule } from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import { InputGroupLuogoAreaComponent } from "../input-group-luogo-area/input-group-luogo-area.component";
import { FormBuilder } from '@angular/forms';
import { UserDeleghe } from '../../models/user.model';
import { InputDatetimeComponent } from "../../../../shared/components/inputs/input-datetime/input-datetime.component";
import { UserRoleService } from '../../user-role.service'
import { ReactiveFormsModule } from "@angular/forms";
@Component({
  selector: 'app-my-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MyButtonComponent,
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    InputGroupLuogoAreaComponent,
    InputDatetimeComponent
],
  templateUrl: './my-dialog.component.html',
  styleUrl: './my-dialog.component.css'
})
export class MyDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MyDialogComponent>, 
    protected readonly fb: FormBuilder,
    private roleService: UserRoleService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {

    
  }
  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }
  closeModal(): void {
    this.dialogRef.close();
  }

  saveModal(): void {

    if(this.data.form.valid){
      let datiAssignRole ={
        roleId:this.data.form.get("roleId").value,
        userId:this.data.model.id.toString(),
        validFrom:this.data.form.get("validFrom").value,
        validTo:this.data.form.get("validTo").value
      }
      this.roleService.assignRole(datiAssignRole).subscribe(val=>{
  
        this.data.form.get("roleId").reset()
        this.data.form.get("validFrom").reset()
        this.data.form.get("validTo").reset()
      
        this.data.reload.emit()
      }) 
     
      this.dialogRef.close();
    }

  }
}
